import { LoadingButton } from '@mui/lab';
import { Box, Tooltip } from '@mui/material';

interface Props {
  isDisabled?: boolean;
  isLoading?: boolean;
  isInCart?: boolean;
  onClick: () => void;
  quantity?: number;
  maxQuantity?: number;
  insufficientStockText?: string;
}

// Mobile card variant: full-width text LoadingButton with the original
// "Update" / "In Basket" / insufficientStockText labels. Kept separate from the
// icon-only `UpdateProductButton` used elsewhere.
export default function UpdateProductButtonMobile({
  isDisabled,
  isLoading,
  isInCart,
  onClick,
  quantity,
  maxQuantity,
  insufficientStockText = 'No Stock',
}: Props) {
  const insufficientStock = !!quantity && !!maxQuantity && quantity > maxQuantity;

  // True when the row's quantity matches the cart — the "nothing to update, already in basket" state.
  // Callers that don't pass isInCart fall back to isDisabled to preserve prior behaviour.
  const showInCartLabel = isInCart ?? isDisabled;

  const buttonProps = {
    'aria-label': !isDisabled ? 'Update quantity' : undefined,
    fullWidth: true,
    loading: isLoading,
    variant: 'outlined' as const,
    disabled: isDisabled || insufficientStock,
    onClick,
  };

  if (insufficientStock) {
    return (
      <Tooltip title={`Quantity must be ${maxQuantity} or less`}>
        <Box width="100%">
          <LoadingButton sx={{ color: '#000' }} {...buttonProps}>
            {insufficientStockText}
          </LoadingButton>
        </Box>
      </Tooltip>
    );
  }

  return (
    <LoadingButton sx={{ color: '#000' }} {...buttonProps}>
      {showInCartLabel ? 'In Basket' : 'Update'}
    </LoadingButton>
  );
}
